/**
 * Amalgam — metallic silver filling with a subtle brushed gradient, dark
 * outline and a bright specular highlight. Adapts to selected surfaces.
 */
import { SURFACE_POS, SURFACE_SIZE, uid } from "./_shared";

export default function Amalgam({ surfaces = [], toothId }) {
  const spots = (surfaces.length ? surfaces : ["O"]).filter((s) => SURFACE_POS[s]);
  const gid = uid("amal", toothId);

  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#DCE0E6" />
          <stop offset="45%"  stopColor="#8B93A1" />
          <stop offset="100%" stopColor="#4A5260" />
        </linearGradient>
      </defs>
      {spots.map((s) => {
        const { cx, cy } = SURFACE_POS[s];
        const { rx, ry } = SURFACE_SIZE[s];
        return (
          <g key={s}>
            {/* Base metallic mass */}
            <ellipse cx={cx} cy={cy} rx={rx - 1} ry={ry - 1}
                     fill={`url(#${gid})`}
                     stroke="#2A2E36" strokeWidth={0.5} />
            {/* Micro brushed texture bands */}
            <path d={`M ${cx - rx + 2} ${cy - 1}
                      Q ${cx} ${cy - 2} ${cx + rx - 2} ${cy - 1}`}
                  fill="none" stroke="#F1F3F6" strokeOpacity={0.35} strokeWidth={0.5} />
            <path d={`M ${cx - rx + 2} ${cy + 2}
                      Q ${cx} ${cy + 3} ${cx + rx - 2} ${cy + 2}`}
                  fill="none" stroke="#2A2E36" strokeOpacity={0.4} strokeWidth={0.5} />
            {/* Specular highlight */}
            <ellipse cx={cx - rx * 0.3} cy={cy - ry * 0.45}
                     rx={rx * 0.35} ry={ry * 0.22}
                     fill="#FFFFFF" fillOpacity={0.7} />
          </g>
        );
      })}
    </g>
  );
}
